import { ImageSizes } from './types';

export const LANDSCAPE_SOURCE_ASPECT = 16 / 9;
export const PORTRAIT_FRAME_ASPECT = 2 / 3;
export const TEASER_SCHOOL_COLUMN_BREAKPOINTS = [
  '31.25rem',
  '48rem',
  '67rem',
  '92rem',
];

const portraitCropWidth = (columns: number): string =>
  `${Math.ceil((100 / columns) * (LANDSCAPE_SOURCE_ASPECT / PORTRAIT_FRAME_ASPECT))}vw`;

const portraitCropSizes = (columnBreakpoints: string[]): ImageSizes => ({
  ...Object.fromEntries(
    columnBreakpoints.map((breakpoint, index) => [
      breakpoint,
      portraitCropWidth(index + 1),
    ]),
  ),
  max: portraitCropWidth(columnBreakpoints.length + 1),
});

const imageSizes: Record<string, Record<string, ImageSizes | undefined>> = {
  default: {
    default: {
      max: '40rem',
    },
    tile: {
      max: '40rem',
    },
    list: {
      '40rem': '40rem',
      '106rem': '20vw',
      max: '22rem',
    },
  },
  'teaser-fullbleed': {
    default: undefined,
  },
  'teaser-school': {
    default: portraitCropSizes(TEASER_SCHOOL_COLUMN_BREAKPOINTS),
  },
  testimonial: {
    default: {
      '106rem': '23vw',
      max: '23rem',
    },
  },
  'testimonial-prominent': {
    default: {
      max: '5rem',
    },
  },
};

export const generateImageSizes = (
  imageSizes?: ImageSizes,
): string | undefined => {
  if (!imageSizes) {
    imageSizes = {};
  }
  const maxSize = imageSizes?.['max'] || '106rem';
  const sizes: string[] = [];
  Object.entries(imageSizes).forEach(([key, value]) => {
    if (key === 'max') return;
    sizes.push(`(max-width: calc(${key} - 1px)) ${value}`);
  });
  sizes.push(maxSize);
  return sizes.join(', ');
};

export const getListingImageSizes = (
  type: string,
  style?: string,
  list?: boolean,
): ImageSizes | undefined => {
  if (list) {
    style = 'list';
  }
  let sizes = imageSizes?.[type || 'default'] || imageSizes['default'];
  return sizes?.[style || 'default'] || sizes?.['default'] || undefined;
};
